import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'NotPassSearch',
})
export class NotPassSearchPipe implements PipeTransform {
  constructor() {}

  transform(items: Array<any>, keyword: string): Array<any> {
    // 키워드가 있을 때
    if (keyword && items) {
      return items.filter(ele => {
        return ele.shopId?.owner.indexOf(keyword) > -1 || ele.email.indexOf(keyword) > -1 || ele.shopId?.shopName.indexOf(keyword) > -1;
      });
    }
    // 키워드가 없을 때
    if (!keyword && items) {
      return items;
    }
  }
}
